var $ = require('jquery');

var updateHiddenInputs = {
    updateValue: function _updateValue($el) {
        var cnFirstCopy = $el.data('cn-first-copy');
        if (cnFirstCopy) {
            var shouldUpdateHiddenInputs = cnFirstCopy.addExtraAttributes === "true" ? true : false;
            if (shouldUpdateHiddenInputs) {
                var requiredDlAttributes = cnFirstCopy.dataLayerHiddenInputs;
                if (requiredDlAttributes && dataLayer) {
                    requiredDlAttributes.forEach(function(key) {
                        var $selectedElem = $el.find('#dataLayer_' + key);
                        if (dataLayer[key]) {
                            $selectedElem.attr('value', dataLayer[key]);
                        } else {
                            $selectedElem.remove();
                        }
                    });
                }
            }
        }
    }
};
module.exports = updateHiddenInputs;
